
<div class="menu-contents"> 
    <div *ngFor="let election of elections"
        [ngClass]="election.electionStatus===ElectionStatusEnum.final ? 'election-title-final' : 'election-title-counting'">
        {{election.electionEvent}}&nbsp;&nbsp;
        {{election.electionStatus===ElectionStatusEnum.precount ? 'Pending Count' : ''}}
        {{election.electionStatus===ElectionStatusEnum.final ? 'Final' : ''}}
        {{election.electionStatus!==ElectionStatusEnum.precount&&election.electionStatus!==ElectionStatusEnum.final ? 'Counting' : ''}}
        <div *ngIf="election.districts!==null" >
            <div [ngClass]="election.electionStatus===ElectionStatusEnum.final ? 'ha-final' : 'ha-count'">
                House of Assembly
            </div>
            <div *ngFor="let district of election.districts" style="margin-left: 15px;">
                <div *ngIf="'byElectionDistrict'+election.electionDateString+district!==selectedButton">
                    <button mat-button 
                        [color]="election.electionStatus===ElectionStatusEnum.final ? 'final' : 'count'"
                        (click)="buttonByElectionDistrictClick(election.electionDateString, district);">
                        District of {{district}}
                    </button>
                </div>
                <div *ngIf="'byElectionDistrict'+election.electionDateString+district===selectedButton">
                    <button mat-flat-button 
                        [color]="election.electionStatus===ElectionStatusEnum.final ? 'final-select' : 'count-select'" 
                        >
                        District of {{district}}
                    </button>
                </div>

            </div>
        </div>
        <div *ngIf="election.districts===null">
            <div [ngClass]="election.electionStatus===ElectionStatusEnum.final ? 'ha-final' : 'ha-count'">
                House of Assembly
            </div>
            <div style="margin-left: 15px;">
                <div *ngIf="'HAStateWide'+election.electionDateString!==selectedButton">
                    <button mat-button 
                    [color]="election.electionStatus===ElectionStatusEnum.final ? 'final' : 'count'"
                        (click)="buttonCountStateWideClick(election.electionDateString)">
                        Statewide Results
                    </button>
                </div>
                <div *ngIf="'HAStateWide'+election.electionDateString===selectedButton">
                    <button mat-flat-button 
                        [color]="election.electionStatus===ElectionStatusEnum.final ? 'final-select' : 'count-select'"
                        (click)="buttonCountStateWideClick(election.electionDateString)">
                        Statewide Results
                    </button>
                </div>
            </div>

            <div style="margin-left: 15px;">
                <div *ngIf="'HAStateWideDistrict'+election.electionDateString!==selectedButton">
                    <button mat-button 
                        style="color:rgb(248, 248, 246)"
                        (click)="buttonCountDistrictClick(election.electionDateString)">
                        District Results
                        <mat-icon *ngIf="showCountDistricts===false" style="color:rgb(248, 248, 246)">
                            expand_more
                        </mat-icon>
                        <mat-icon *ngIf="showCountDistricts===true" style="color:rgb(248, 248, 246)">
                            expand_less
                        </mat-icon>
                    </button>
                </div>
                <div *ngIf="'HAStateWideDistrict'+election.electionDateString===selectedButton">
                    <button button mat-flat-button color="Primary" 
                        style="color:rgb(31, 31, 30)"
                        (click)="buttonCountDistrictClick(election.electionDateString)">
                        District Results
                        <mat-icon *ngIf="showCountDistricts===false" style="color:rgb(31, 31, 30)">
                            expand_more
                        </mat-icon>
                        <mat-icon *ngIf="showCountDistricts===true" style="color:rgb(31, 31, 30)">
                            expand_less
                        </mat-icon>
                    </button>
                </div>
            </div>
            <div *ngIf="showCountDistricts===true" style="margin-left: 10px; margin-bottom: 24px; margin-top: -10px; width: 310px;">
                <mat-chip-list class="district-chip-list">
                    <mat-chip *ngFor="let districtName of countDistrictNames"  
                   
                    class="district-chip"
                    (click)="clickDistrict(election.electionDateString, districtName)"
                    [selected]="districtName===selectedDistrict">
                        {{districtName}}
                    </mat-chip>
                </mat-chip-list>
            </div>
        
            <div [ngClass]="election.electionStatus===ElectionStatusEnum.final ? 'ha-final' : 'ha-count'">
                Legislative Council
            </div>
            <div style="margin-left: 15px;">
                <div *ngIf="'LCStateWide'+election.electionDateString!==selectedButton">
                    <button mat-button 
                        style="color:rgb(248, 248, 246)"
                        (click)="buttonCountLCStateWideClick(election.electionDateString)">
                        Statewide Results
                    </button>
                </div>
                <div *ngIf="'LCStateWide'+election.electionDateString===selectedButton">
                    <button button mat-flat-button color="Primary" 
                        style="color:rgb(31, 31, 30)">
                        Statewide Results
                    </button>
                </div>
            </div>
        </div>
        <div style="margin-top: 20px; margin-bottom: 15px;">
            <mat-divider></mat-divider>
        </div>
    </div>




    <!-- <div style="margin-left: 10px; color: rgb(248, 248, 246); width: 310px;">
        State Election (19 Mar 2022)&nbsp;&nbsp; Final
    </div>
    <div style="margin-left: 10px; margin-top: 20px; color: rgb(187, 187, 189);">
        House of Assembly
    </div>
  
    <div>
        <button mat-button 
            style="color:rgb(248, 248, 246)"
            (click)="buttonCountStateWideClick()">
            Statewide Results
        </button>
    </div>
    <div>
        <button mat-button 
            style="color:rgb(248, 248, 246)"
            (click)="buttonCountDistrictClick()">
            District Results
        </button>
        <button mat-icon-button *ngIf="showCountDistricts===false" 
            (click)="buttonCountDistrictClick()">
            <mat-icon style="color:rgb(248, 248, 246)">
                expand_more
            </mat-icon>
        </button>
        <button mat-icon-button *ngIf="showCountDistricts===true"
            (click)="buttonCountDistrictClick()">
            <mat-icon style="color:rgb(248, 248, 246)">
                expand_less
            </mat-icon>
        </button>
    </div>
    <div *ngIf="showCountDistricts===true" style="margin-left: 10px; margin-bottom: 24px; margin-top: -10px; width: 310px;">
        <mat-chip-list class="district-chip-list">
            <mat-chip *ngFor="let districtName of countDistrictNames"  
            style="color: rgb(184, 184, 181);"
            class="district-chip"
            (click)="clickDistrict(districtName)"
            [selected]="districtName===selectedDistrict">
                {{districtName}}
            </mat-chip>
        </mat-chip-list>
    </div>

    <div style="margin-left: 10px; margin-top: 20px; color: rgb(187, 187, 189)">
        Legislative Council
    </div>
    <div>
        <button mat-button 
            style="color:rgb(248, 248, 246)"
            (click)="buttonCountLCStateWideClick()">
            Statewide Results
        </button>
    </div> -->



 <!--
    <div style="margin-left: 10px; color: rgb(252, 240, 140); width: 310px;">
        State Election (19 Mar 2022)&nbsp;&nbsp; Final
    </div>
    <div style="margin-left: 10px; margin-top: 20px; color: rgb(153, 142, 45);">
        House of Assembly
    </div>
  
    <div>
        <button mat-button 
            style="color:rgb(252, 240, 140)"
            (click)="buttonCountStateWideClick()">
            Statewide Results
        </button>
    </div>
    <div>
        <button mat-button 
            style="color:rgb(252, 240, 140)"
            (click)="buttonCountDistrictClick()">
            District Results
        </button>
        <button mat-icon-button *ngIf="showCountDistricts===false" 
            (click)="buttonCountDistrictClick()">
            <mat-icon style="color:rgb(252, 240, 140)">
                expand_more
            </mat-icon>
        </button>
        <button mat-icon-button *ngIf="showCountDistricts===true"
            (click)="buttonCountDistrictClick()">
            <mat-icon style="color:rgb(252, 240, 140)">
                expand_less
            </mat-icon>
        </button>
    </div>
    <div *ngIf="showCountDistricts===true" style="margin-left: 10px; margin-bottom: 24px; margin-top: -10px; width: 310px;">
        <mat-chip-list class="district-chip-list">
            <mat-chip *ngFor="let districtName of countDistrictNames"  
            style="color: rgb(250, 244, 187);"
            class="district-chip"
            (click)="clickDistrict(districtName)"
            [selected]="districtName===selectedDistrict">
                {{districtName}}
            </mat-chip>
        </mat-chip-list>
    </div>





    <div style="margin-left: 10px; margin-top: 20px; color: rgb(153, 142, 45)">
        Legislative Council
    </div>
    <div>
        <button mat-button 
            style="color:rgb(252, 240, 140)"
            (click)="buttonCountLCStateWideClick()">
            Statewide Results
        </button>
    </div> -->


    <!-- <div style="margin-left: 10px; margin-top:35px; color: rgb(187, 187, 189); font-size: 14px;">
        Previous Election Results
    </div>
    <mat-divider style="border-top-color: rgb(187, 187, 189);"></mat-divider>
    <div style="margin-left: 10px; margin-top:29px;">
        State Election (17 Mar 2018)&nbsp;&nbsp; Final Results
    </div>
    <div style="margin-left: 10px; margin-top: 20px; color: rgb(187, 187, 189);">
        House of Assembly
    </div>
    <div>
        <button mat-button (click)="buttonHistoryStateWideClick()">Statewide Results</button>
    </div>
    <div>
        <button mat-button (click)="buttonHistoryDistrictClick()">District Results</button>

        <button mat-icon-button *ngIf="showCountDistricts===false"
            (click)="buttonHistoryDistrictClick()">
            <mat-icon>
                expand_more
            </mat-icon>
        </button>
        <button mat-icon-button *ngIf="showCountDistricts===true"
            (click)="buttonHistoryDistrictClick()">
            <mat-icon>
                expand_less
            </mat-icon>
        </button>
    </div>
    <div *ngIf="showHistoryDistricts===true" style="margin-left: 10px; width: 310px;">
        <mat-chip-list class="district-chip-list">
            <mat-chip *ngFor="let districtName of historyDistrictNames"  
            class="district-chip"
            (click)="clickHistoryDistrict(districtName)"
            [selected]="districtName===selectedHistoryDistrict">
                {{districtName}}
            </mat-chip>
        </mat-chip-list>
    </div> -->
</div>



